import {
  CircularProgress,
  Divider,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import {
  StyledTableCell,
} from "../../customComponents/styled/styledTable";
import { useGetMyActivityQuery } from "./dashboardApiSlice";
import { formatUtcDatetime } from "../../../helpers/dateUtils";

function NotificationsCard() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data, isLoading } = useGetMyActivityQuery({ page: page + 1, per_page: rowsPerPage });

  const activities = data?.activities ?? [];
  const total = data?.total ?? 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Box className="paperHeader">
        <Typography gutterBottom>My Activity</Typography>
        <Divider />
      </Box>
      <Box className="paperBody">
        <TableContainer sx={{ pb: 4 }}>
          <Table sx={{ width: "100%", boxShadow: "none" }}>
            <TableHead>
              <TableRow>
                <StyledTableCell>notification</StyledTableCell>
                <StyledTableCell align="left">date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <StyledTableCell colSpan={2} align="center">
                    <Box sx={{ display: "flex", justifyContent: "center", marginBlock: 4 }}>
                      <CircularProgress />
                    </Box>
                  </StyledTableCell>
                </TableRow>
              ) : (
                activities?.map((row, i) => (
                  <TableRow key={i} sx={{ background: (theme) => theme.palette.mode === "dark" ? "#2a2a2a" : "#f5f5f5" }}>
                    <StyledTableCell component="th" scope="row">
                      {row?.message}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {row?.created_at && formatUtcDatetime(row.created_at)}
                    </StyledTableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Box>
    </>
  );
}

export default NotificationsCard;
